import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import {
  GET_BOOKING_LIFECYCLE_TIMELINE,
  GET_BOOKING_LIFECYCLE_TIMELINE_SUCCESS,
  GET_BOOKING_LIFECYCLE_TIMELINE_ERROR,
} from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getBookingLifecycleTimeline({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    /* query: booking_id, ticket_id, sub_category_id, user_id */
    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/booking-lifecycle-timeline`,
      method: 'GET',
      headers: { ...filteredHeaders },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_BOOKING_LIFECYCLE_TIMELINE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BOOKING_LIFECYCLE_TIMELINE_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BOOKING_LIFECYCLE_TIMELINE_ERROR, payload: error });
  }
}

export function* watchGetBookingLifecycleTimeline() {
  yield takeEvery(GET_BOOKING_LIFECYCLE_TIMELINE, getBookingLifecycleTimeline);
}

function* getBookingLifecycleTimelineSaga() {
  yield all([fork(watchGetBookingLifecycleTimeline)]);
}

export default getBookingLifecycleTimelineSaga;
